export const shortenAddress = (address: string) =>
  address.length <= 10 ? address : `${address.slice(0, 4)}…${address.slice(-4)}`
